class RegisterTab {
  constructor(){
    this.registerTabs = document.querySelectorAll('.lc-register-tabs').forEach(registerTab => {
      this.setupRegisterTab(registerTab);
    });
  }

  setupRegisterTab(registerTab) {
    const tabContents = registerTab.querySelectorAll('.lc-register-tabs__content');
    const nav = registerTab.querySelector('.lc-tabs__nav');

    tabContents.forEach(tabContent => {
      const title = tabContent.querySelector('.lc-register-tabs__title').innerText.trim();
      const navTab = document.createElement('li');
      navTab.classList.add('lc-tabs-nav__list');
      navTab.innerHTML = `<button type="button" class="lc-tabs-link"><span class="lc-tabs-link-text">${title}</span></button>`;
      navTab.addEventListener('click', () => {
        this.disableTabs(registerTab);
        navTab.classList.add('tab-active');
        tabContent.classList.add('tab-active');
      });

      nav.append(navTab)
    });


    nav.querySelector('li')?.click();
  }

  disableTabs(registerTab) {
    registerTab.querySelectorAll('.lc-register-tabs__content, .lc-tabs-nav__list').forEach(t => t.classList.remove('tab-active'));
  }
}

export default RegisterTab;
